<template>
  <div class="article-tags__wrapper">
    <div class="article-tags__label">
      Topics
    </div>
    <div class="article-tags__list">
      <a-tag
        v-for="(tag, i) in tags"
        :key="`${prop('Name', tag)}${i}`"
        :tag="tag"
      />
    </div>
  </div>
</template>

<script>
import { prop } from 'ramda'

import ATag from '@/components/_shared/ATag'

export default {
  name: 'AArticleTagsList',
  components: { ATag },
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    prop
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/styles/article';

.article-tags__wrapper {
  .article-tags__label {
    @extend .section-subtitle;
  }

  .article-tags__list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }
}
</style>
